import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Search } from "lucide-react";
import { PageHeader, Spinner, Table, THead, TR, TH, TD, Badge, Input } from "./_ui";

export default function MembresPanel() {
  const [users, setUsers] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);

  if (!users) return (<><PageHeader title="Membres" /><Spinner /></>);

  const filtered = users.filter((u) =>
    !q ||
    (u.name || "").toLowerCase().includes(q.toLowerCase()) ||
    (u.email || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="admin-members">
      <PageHeader
        title="Membres"
        subtitle={`${users.length} comptes inscrits — ${users.filter((u) => u.role === "member").length} membres, ${users.filter((u) => u.role === "admin").length} admins`}
      />
      <div className="mb-4 max-w-md relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input
          value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Rechercher par nom ou email…" className="pl-9"
          data-testid="members-search"
        />
      </div>
      <Table>
        <THead>
          <tr><TH>Nom</TH><TH>Email</TH><TH>Rôle</TH><TH>Authentification</TH><TH>Inscription</TH></tr>
        </THead>
        <tbody>
          {filtered.map((u) => (
            <TR key={u.user_id} data-testid={`member-${u.user_id}`}>
              <TD className="text-white font-medium">{u.name}</TD>
              <TD>{u.email}</TD>
              <TD>
                <Badge color={u.role === "admin" ? "gold" : "blue"}>{u.role}</Badge>
              </TD>
              <TD className="text-xs">{u.auth_method}</TD>
              <TD className="text-xs">{new Date(u.created_at).toLocaleDateString("fr-FR")}</TD>
            </TR>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
